import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { DownloadSuccessOverlayComponent } from './shared/components/download-success-overlay/download-success-overlay.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, DownloadSuccessOverlayComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'EXPERT';
}
